import { Controller } from '@hotwired/stimulus'
import Swiper from 'swiper/core'
import parsePhoneNumber from 'libphonenumber-js/max'
import { getAddress } from '../api/common/search_address'
import { getDiagnoseFacilities } from '../api/common/diagnose_facilities'
import delay from 'lodash/delay'

const DELAY_TIME = 800

export default class extends Controller {
  static targets = [
    'main',
    'form',
    'question',
    'diagnosePrefectures',
    'diagnosePrefecture',
    'diagnoseCities',
    'diagnoseCity',
    'postcode',
    'postcodeError',
    'prefectures',
    'cities',
    'towns',
    'email',
    'suggest',
    'telInput',
    'telError',
    'footer',
    'submit',
    'text',
    'modal',
    'currentStatusText',
    'attributesText',
    'demandPlaceholder',
    'nameButton',
    'normalQuestion',
    'skipQuestion',
    'leaveModal',
    'diagnoseCarousel',
    'diagnoseCarouselList',
    'attributesCarousel1',
    'attributesCarouselList1',
    'attributesCarousel2',
    'attributesCarouselList2',
  ]

  static values = {
    abCategory: String,
  }

  static classes = [
    'displayVisible',
    'displayHidden',
    'visibilityVisible',
    'visibilityHidden',
    'valid',
    'invalid',
  ]

  get controllerName () {
    return this.element.dataset.controller
  }

  get className () {
    return this.element.dataset.classname
  }

  get prefectureId () {
    return this.prefecturesTarget.value
  }

  get cityId () {
    return this.citiesTarget.value
  }

  connect () {
    // デバッグ用
    this.isDevelop = false

    this.isValidTel = false
    this.diagnoseResults = []

    window.addEventListener('beforeunload', this.openUnloadDialog)

    // コラムCTAから入力値を引き継ぐ場合は、入力をスキップして5からはじめる
    const url = new URL(window.location.href)
    const params = url.searchParams

    if (params.has('occupant_current_status_id') && params.has('occupant_timing_id') && params.has('occupant_gender') && params.has('occupant_age') && params.has('occupant_care_level')) {
      // 要素が存在する場合のみremoveを実行
      this.normalQuestionTarget?.remove()

      const currentStatus = this.formTarget.elements['inquiry[occupant_current_status_id]']
      const gender = this.formTarget.elements['inquiry[occupant_gender]']
      const age = this.formTarget.elements['inquiry[occupant_age]']
      const careLevel = this.formTarget.elements['inquiry[occupant_care_level_id]']
      const timing = this.formTarget.elements['inquiry[occupant_timing_id]']

      currentStatus.value = params.get('occupant_current_status_id')
      gender.value = params.get('occupant_gender')
      const ageValue = Math.floor(params.get('occupant_age') / 10) * 10
      if (ageValue >= 60 && ageValue <= 90) {
        age.value = ageValue
      } else {
        age.value = -1
      }
      careLevel.value = params.get('occupant_care_level')
      timing.value = params.get('occupant_timing_id')

      this.showNextChat(5)
    } else {
      // 要素が存在する場合のみremoveを実行
      this.skipQuestionTarget?.remove()
      this.questionTargets[0].classList.add(this.displayVisibleClass)
    }
  }

  openUnloadDialog (e) {
    e.preventDefault()
    e.returnValue = ''
  }

  hideCurrentQuestion (step) {
    this.questionTargets[step - 1].classList.remove(this.displayVisibleClass)
  }

  showNextQuestion (step) {
    this.questionTargets[step - 1].classList.add(this.displayVisibleClass)
    console.log(`next:${step}`)
  }

  nextQuestion (e) {
    this.hideCurrentQuestion(e.currentTarget.dataset.current)
    this.showNextQuestion(e.currentTarget.dataset.next)
  }

  nextQuestionChoseCurrentStatus (e) {
    if (this.hasCurrentStatusTextTarget) {
      this.currentStatusTextTarget.innerHTML = e.target.dataset.title
    }
    this.hideCurrentQuestion(e.currentTarget.dataset.current)
    this.showNextQuestion(e.currentTarget.dataset.next)
  }

  hideCurrentChatInput (e, text) {
    const title = e.currentTarget.dataset.title
    const current = e.currentTarget.dataset.current
    const currentInput = document.getElementById(`chat_input_${current}`)
    currentInput.classList.add(this.displayHiddenClass)
    currentInput.insertAdjacentHTML('beforebegin', `
      <div class="${this.element.dataset.classname}::chat-answer-container">
      <div class="${this.element.dataset.classname}::chat-answer-read">既読</div>
        <div class="${this.element.dataset.classname}::chat-answer">${text || title}</div>
      </div>
    `)
  }

  showNextChat (step) {
    const chatQuestionContainer = document.getElementById(`chat_question_container_${step}`)
    const chatInput = document.getElementById(`chat_input_${step}`)
    const loaders = chatQuestionContainer.getElementsByClassName(`${this.className}::loader`)
    const chatQuestions = chatQuestionContainer.getElementsByClassName(`${this.className}::chat-question`)
    const nextDom = this.questionTargets[step - 1]

    this.questionTargets[step - 1].style.display = 'block'
    delay(() => {
      chatQuestionContainer.classList.add(this.visibilityVisibleClass)
    }, DELAY_TIME)
    Array.from(chatQuestions).forEach((elm, index) => {
      delay(() => {
        loaders[index].classList.add(this.displayHiddenClass)
        chatQuestions[index].classList.add(this.displayVisibleClass)
      }, DELAY_TIME * (index + 2))
      delay(() => {
        window.scroll({ top: nextDom.offsetTop, left: 0, behavior: 'smooth' })
      }, DELAY_TIME * (index + 2))
    })
    delay(() => {
      chatInput.classList.add(this.visibilityVisibleClass)
    }, DELAY_TIME * (chatQuestions.length + 2))

    console.log(`next:${step}`)
  }

  appendChatInputs (step) {
    const template = document.getElementById(`chat_template_${step}`)
    const clone = template.content.cloneNode(true)
    document.getElementById(`chat_append_${step}`).appendChild(clone)
  }

  nextFirstChat (e) {
    this.hideCurrentQuestion(e.currentTarget.dataset.current)
    this.showNextChat(e.currentTarget.dataset.next)
  }

  nextChatWithScroll (e) {
    this.hideCurrentChatInput(e)
    this.showNextChat(e.currentTarget.dataset.next)
  }

  nextChatChoseOccupantTiming (e) {
    if (this.formTarget.elements['inquiry[occupant_timing_id]'].value !== '') {
      this.hideCurrentChatInput(e)
      this.showNextChat(Number(e.currentTarget.dataset.next) + 1)
    } else {
      this.nextChatWithScroll(e)
    }
  }

  nextChatPrefectures (e) {
    const regionId = e.target.value
    const nextStep = e.currentTarget.dataset.next
    this.hideCurrentChatInput(e)
    fetch(`/area/regions/${regionId}/prefectures.json`)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP Error: ${response.status}`)
        return response.json()
      })
      .then(prefectures => {
        this.updateDiagnosePrefectures(prefectures)
        this.showNextChat(nextStep)
      })
      .catch(error => {
        if (typeof Sentry !== 'undefined') {
          Sentry.captureException(error, { tags: { component: 'inquiry-chat-recommend', operation: 'fetch-prefectures' } })
        }
        console.error('Failed to fetch prefectures:', error)
      })
  }

  nextChatChoseCity (e) {
    this.modalTarget.classList.add(this.displayHiddenClass)
    this.hideCurrentChatInput(e, `${this.diagnosePrefectureTarget.innerHTML}${e.target.dataset.title}`)
    this.showNextChat(e.currentTarget.dataset.next)
  }

  getDiagnoseFacilityParams () {
    let params = {}
    let careLevelId = null
    let monthlyFeeMin = null
    let monthlyFeeMax = null
    let welfareAcceptable = null
    let dementiaAcceptable = null
    let diabetes = false
    const specialFeatureValues = []

    // 入居希望者の介護度
    if (this.formTarget.elements['inquiry[occupant_care_level_id]'] &&
      Number(this.formTarget.elements['inquiry[occupant_care_level_id]'].value) >= 0 &&
      this.formTarget.elements['inquiry[occupant_care_level_id]'].value !== '30') {
      careLevelId = this.formTarget.elements['inquiry[occupant_care_level_id]'].value
    }

    // 月額予算
    switch (this.formTarget.elements['inquiry[expected_monthly_fee_id]'].value) {
      case '10':
        monthlyFeeMin = 120000
        monthlyFeeMax = 239999
        break
      case '20':
        monthlyFeeMin = null
        monthlyFeeMax = 119999
        break
      case '30':
        monthlyFeeMin = 240000
        monthlyFeeMax = null
        break
      default:
        monthlyFeeMin = null
        monthlyFeeMax = null
        break
    }

    // こだわり条件
    this.formTarget.elements['inquiry[special_feature_names][]'].forEach(elm => {
      if (elm.checked) {
        specialFeatureValues.push(elm.value)
      }
    })

    // 認知症の症状
    if (this.formTarget.elements['inquiry[occupant_dementia_id]'] &&
      this.formTarget.elements['inquiry[occupant_dementia_id]'].value === '1') {
      dementiaAcceptable = this.formTarget.elements['inquiry[occupant_dementia_id]'].value
    }

    // 糖尿病の症状
    if (this.formTarget.elements['inquiry[occupant_diabetes]'] &&
      this.formTarget.elements['inquiry[occupant_diabetes]'].value === '1') {
      diabetes = true
    }

    // 生活保護の受給状況
    if (this.formTarget.elements['inquiry[occupant_social_security_status_id]'] &&
      this.formTarget.elements['inquiry[occupant_social_security_status_id]'].value === '1') {
      welfareAcceptable = this.formTarget.elements['inquiry[occupant_social_security_status_id]'].value
    }

    // こだわり条件の「認知症相談可」が選択されている場合は認知症の症状を「あり」に設定
    if (specialFeatureValues.includes('ninchisyo')) {
      dementiaAcceptable = '1'
    }

    // こだわり条件の「生活保護相談可」が選択されている場合は生活保護の受給状況を「あり」に設定
    if (specialFeatureValues.includes('seikatuhogo')) {
      welfareAcceptable = '1'
    }

    params = {
      prefecture_id: this.formTarget.elements['inquiry[diagnose_prefecture_id]'] ? this.formTarget.elements['inquiry[diagnose_prefecture_id]'].value : null,
      city_ids: this.formTarget.elements['inquiry[diagnose_city_id]'] ? [this.formTarget.elements['inquiry[diagnose_city_id]'].value] : null,
      monthly_fee_min: monthlyFeeMin,
      monthly_fee_max: monthlyFeeMax,
      welfare_acceptable: welfareAcceptable,
      dementia_acceptable: dementiaAcceptable,
      medical_care_id: diabetes ? '201' : null,
      care_level_id: careLevelId,
      special_features: specialFeatureValues,
    }

    return params
  }

  diagnoseFacilities (e) {
    const specialFeatureTexts = []

    this.formTarget.elements['inquiry[special_feature_names][]'].forEach(elm => {
      if (elm.checked) {
        specialFeatureTexts.push(elm.dataset.title)
      }
    })
    this.hideCurrentChatInput(e, specialFeatureTexts.length > 0 ? specialFeatureTexts.join('、') : 'ありません')

    getDiagnoseFacilities(this.getDiagnoseFacilityParams()).then((data) => {
      console.log('diagnose success')
      if (data.results.length > 0) {
        // 診断結果が1件以上の場合、スライダーを表示
        this.diagnoseResults = data.results
        this.appendDiagnoseCarousel(data.results, this.diagnoseCarouselTarget, this.diagnoseCarouselListTarget)
        this.showNextChat(17)
        delay(() => {
          this.appendChatInputs(18)
          this.showNextChat(18)
        }, 4000)
      } else {
        // 診断結果が0件の場合、追加の質問を行う
        this.diagnoseResults = []
        this.diagnoseCarouselListTarget.innerHTML = ''
        this.appendChatInputs(16)
        this.showNextChat(16)
      }
    })
  }

  retryDiagnoseFacilities (e) {
    let params = {}
    this.hideCurrentChatInput(e)

    if (e.target.value === 'area') {
      // 「エリアを広げる」を選択した場合
      // 市区町村を設定しない
      params = this.getDiagnoseFacilityParams()
      delete params.city_ids
    } else {
      params = this.getDiagnoseFacilityParams()
      // 「予算を広げる」を選択した場合
      // 予算設定を変更
      switch (this.formTarget.elements['inquiry[expected_monthly_fee_id]'].value) {
        case '10':
          params.monthly_fee_min = 240000
          params.monthly_fee_max = null
          break
        case '20':
          params.monthlyFeeMin = 120000
          params.monthlyFeeMax = 239999
          break
        case '30':
          params.monthlyFeeMin = 240000
          params.monthlyFeeMax = null
          break
        default:
          params.monthlyFeeMin = 240000
          params.monthlyFeeMax = null
          break
      }
    }

    getDiagnoseFacilities(params).then((data) => {
      console.log('diagnose success')
      if (data.results.length > 0) {
        // 診断結果が1件以上の場合、スライダーを表示
        this.diagnoseResults = data.results
        this.appendDiagnoseCarousel(data.results, this.diagnoseCarouselTarget, this.diagnoseCarouselListTarget)
        this.showNextChat(17)
        delay(() => {
          this.appendChatInputs(18)
          this.showNextChat(18)
        }, 4000)
      } else {
        // 診断結果が0件の場合
        this.diagnoseResults = []
        this.appendChatInputs(26)
        this.showNextChat(26)
        delay(() => {
          this.footerTarget.classList.add(this.displayVisibleClass)
        }, DELAY_TIME)
      }
    })
  }

  nextCheckFacilities (e) {
    if (this.hasAttributesTextTarget) {
      this.attributesTextTarget.innerHTML = e.target.dataset.title
    }

    this.hideCurrentChatInput(e)

    if (e.target.value === 'request_for_document') {
      this.appendAttributesCarousel(this.diagnoseResults, this.attributesCarousel1Target, this.attributesCarouselList1Target, e.target.value)
      this.showNextChat(19)
    } else {
      this.appendAttributesCarousel(this.diagnoseResults, this.attributesCarousel2Target, this.attributesCarouselList2Target, e.target.value)
      this.showNextChat(23)
    }
  }

  nextDemand (e) {
    this.hideCurrentChatInput(e, '次へ')
    this.appendChatInputs(20)
    this.showNextChat(20)
  }

  requestAllNextDemand (e) {
    this.attributesCarousel1Target.querySelectorAll("input[type='checkbox']").forEach(elm => {
      elm.checked = true
    })
    this.hideCurrentChatInput(e, 'まとめて確認')
    this.appendChatInputs(20)
    this.showNextChat(20)
  }

  nextDemand2 (e) {
    this.hideCurrentChatInput(e, '次へ')
    this.appendChatInputs(24)
    this.showNextChat(24)
  }

  requestAllNextDemand2 (e) {
    this.attributesCarousel2Target.querySelectorAll("input[type='checkbox']").forEach(elm => {
      elm.checked = true
    })
    this.hideCurrentChatInput(e, 'まとめて確認')
    this.appendChatInputs(24)
    this.showNextChat(24)
  }

  nextAddress1 (e) {
    this.hideCurrentChatInput(e, '次へ')
    this.appendChatInputs(21)
    this.showNextChat(21)
  }

  nextAddress2 (e) {
    this.hideCurrentChatInput(e, '次へ')
    this.appendChatInputs(22)
    this.showNextChat(22)
    delay(() => {
      this.footerTarget.classList.add(this.displayVisibleClass)
    }, DELAY_TIME)
  }

  nextAddress3 (e) {
    this.hideCurrentChatInput(e, '次へ')
    this.appendChatInputs(25)
    this.showNextChat(25)
    delay(() => {
      this.footerTarget.classList.add(this.displayVisibleClass)
    }, DELAY_TIME)
  }

  nextSubmit (e) {
    this.footerTarget.classList.add(this.displayVisibleClass)
    delay(() => {
      window.scroll({
        top: this.footerTarget.offsetTop + this.footerTarget.clientHeight - window.innerHeight,
        left: 0,
        behavior: 'smooth',
      })
    }, DELAY_TIME)
  }

  submitForm () {
    window.removeEventListener('beforeunload', this.openUnloadDialog)
  }

  changeDemand (e) {
    if (this.hasDemandPlaceholderTarget) {
      if (e.target.value.length === 0) {
        this.demandPlaceholderTarget.style.display = 'block'
      } else {
        this.demandPlaceholderTarget.style.display = 'none'
      }
    }
  }

  inputEmail (e) {
    if (e.target.value.slice(-1) === '@') {
      this.suggestTarget.style.display = 'block'
    }
  }

  clickSuggest (e) {
    this.emailTarget.value = this.emailTarget.value + e.target.dataset.value
    this.suggestTarget.style.display = 'none'
  }

  closeSuggest () {
    this.suggestTarget.style.display = 'none'
  }

  showCitiesModal (e) {
    const prefectureId = e.target.value
    this.diagnosePrefectureTarget.innerHTML = e.target.dataset.title
    this.modalTarget.classList.remove(this.displayHiddenClass)
    fetch(`/area/prefectures/${prefectureId}/cities.json`)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP Error: ${response.status}`)
        return response.json()
      })
      .then(cities => this.updateDiagnoseCities(e, cities))
      .catch(error => {
        if (typeof Sentry !== 'undefined') {
          Sentry.captureException(error, { tags: { component: 'inquiry-chat-recommend', operation: 'fetch-cities-modal' } })
        }
        console.error('Failed to fetch cities:', error)
      })
  }

  updateDiagnoseCities (e, cities) {
    const current = e.target.dataset.current
    const next = e.target.dataset.next
    const action = this.diagnoseCitiesTarget.dataset.nextAction
    const gtagEvent = this.diagnoseCitiesTarget.dataset.gtag
    const gtmEfCategory = this.diagnosePrefecturesTarget.dataset.gtmEfCategory
    const gtmEventName = this.diagnosePrefecturesTarget.dataset.gtmEventName
    this.diagnoseCitiesTarget.innerHTML =
      cities.map((city) => (
        `
          <li>
            <label>
              <input
                type="radio"
                name="inquiry[diagnose_city_id]"
                value="${city.id}"
                class="inquiry-step-button"
                data-gtm-ef-category="${gtmEfCategory}"
                data-gtm-event="${gtmEventName}"
                data-title="${city.name}です"
                data-city="${city.name}"
                data-action="${action}"
                data-current="${current}"
                data-next="${next}"
                onClick="${gtagEvent}"
              />
              ${city.name}
            </label>
          </li>
      `)).join('')
  }

  updateDiagnosePrefectures (prefectures) {
    const current = this.diagnosePrefecturesTarget.dataset.current
    const next = this.diagnosePrefecturesTarget.dataset.next
    const action = this.diagnosePrefecturesTarget.dataset.nextAction
    const gtagEvent = this.diagnosePrefecturesTarget.dataset.gtag
    const gtmEfCategory = this.diagnosePrefecturesTarget.dataset.gtmEfCategory
    const gtmEventName = this.diagnosePrefecturesTarget.dataset.gtmEventName
    const className = this.diagnosePrefecturesTarget.dataset.className
    this.diagnosePrefecturesTarget.innerHTML =
      prefectures.map(prefecture => (
        `
          <label class="${className}">
            <input
              type="radio"
              name="inquiry[diagnose_prefecture_id]"
              value="${prefecture.id}"
              class="inquiry-step-button"
              data-gtm-ef-category="${gtmEfCategory}"
              data-gtm-event="${gtmEventName}"
              data-title="${prefecture.name}"
              data-next="${next}"
              data-current="${current}"
              data-action="${action}"
              onClick="${gtagEvent}"
            />
            <span>${prefecture.name}</span>
          </label>
        `
      )).join('')
  }

  fillAddresses () {
    const param = { post_code: this.postcodeTarget.value }

    getAddress(param).then((address) => {
      if (!address.result.prefecture) {
        this.postcodeErrorTarget.style.display = 'flex'
      } else {
        this.postcodeErrorTarget.style.display = 'none'
        this.prefecturesTarget.value = address.result.prefecture.id
        this.fillCities(address.result.city)
        this.fillTowns(address.result.town)
      }
    })
  }

  async fillCities (selectedCity) {
    try {
      const response = await fetch(`/area/prefectures/${selectedCity.prefecture_id}/cities.json`)
      if (!response.ok) throw new Error(`HTTP Error: ${response.status}`)
      const json = await response.json()
      this.updateCities(json)
      this.citiesTarget.value = selectedCity.id
    } catch (error) {
      if (typeof Sentry !== 'undefined') {
        Sentry.captureException(error, { tags: { component: 'inquiry-chat-recommend', operation: 'fill-cities' } })
      }
      console.error('Failed to fetch cities:', error)
    }
  }

  async fillTowns (selectedTown) {
    try {
      const response = await fetch(`/area/cities/${selectedTown.city_id}/towns`)
      if (!response.ok) throw new Error(`HTTP Error: ${response.status}`)
      const json = await response.json()
      this.updateTowns(json)
      this.townsTarget.value = selectedTown.id
    } catch (error) {
      if (typeof Sentry !== 'undefined') {
        Sentry.captureException(error, { tags: { component: 'inquiry-chat-recommend', operation: 'fill-towns' } })
      }
      console.error('Failed to fetch towns:', error)
    }
  }

  changeCity () {
    if (this.cityId) {
      fetch(`/area/cities/${this.cityId}/towns`)
        .then(response => {
          if (!response.ok) throw new Error(`HTTP Error: ${response.status}`)
          return response.json()
        })
        .then(towns => this.updateTowns(towns))
        .catch(error => {
          if (typeof Sentry !== 'undefined') {
            Sentry.captureException(error, { tags: { component: 'inquiry-chat-recommend', operation: 'fetch-towns' } })
          }
          console.error('Failed to fetch towns:', error)
        })
    }
    this.townsTarget.value = ''
  }

  updateTowns (towns) {
    this.townsTarget.innerHTML =
      '<option value="">町名を選択してください</option>' +
      towns.map((town) => (
        `<option value="${town.id}">${town.name}</option>`
      )).join()
  }

  updateCities (cities) {
    this.citiesTarget.innerHTML =
      '<option value="">市区町村を選択してください</option>' +
      cities.map((city) => (
        `<option value="${city.id}">${city.name}</option>`
      )).join()
  }

  changePrefecture () {
    if (this.prefectureId) {
      fetch(`/area/prefectures/${this.prefectureId}/cities.json`)
        .then(response => {
          if (!response.ok) throw new Error(`HTTP Error: ${response.status}`)
          return response.json()
        })
        .then(cities => this.updateCities(cities))
        .catch(error => {
          if (typeof Sentry !== 'undefined') {
            Sentry.captureException(error, { tags: { component: 'inquiry-chat-recommend', operation: 'fetch-cities' } })
          }
          console.error('Failed to fetch cities:', error)
        })
    }
    this.citiesTarget.value = ''
    this.townsTarget.value = ''
  }

  validateName () {
    if (this.formTarget.elements['inquiry[name]'].value &&
      this.formTarget.elements['inquiry[kana]'].value &&
      this.formTarget.elements['inquiry[email]'].value &&
      this.isValidTel) {
      this.nameButtonTarget.disabled = false
    } else {
      this.nameButtonTarget.disabled = true
    }
  }

  validateName2 () {
    if (this.formTarget.elements['inquiry[email]'].value &&
      this.isValidTel) {
      this.submitTarget.disabled = false
    } else {
      this.submitTarget.disabled = true
    }
  }

  validateName3 () {
    if (this.isValidTel) {
      this.submitTarget.disabled = false
    } else {
      this.submitTarget.disabled = true
    }
  }

  validateAddress () {
    if (this.formTarget.elements['inquiry[prefecture_id]'].value &&
      this.formTarget.elements['inquiry[city_id]'].value &&
      this.formTarget.elements['inquiry[town_id]'].value &&
      this.formTarget.elements['inquiry[address]'].value) {
      this.submitTarget.disabled = false
    } else {
      this.submitTarget.disabled = true
    }
  }

  validateTel () {
    const value = this.telInputTarget.value
    if (value) {
      const phoneNumber = parsePhoneNumber(value, 'JP')
      if (phoneNumber?.isValid()) {
        this.isValidTel = true
        this.telErrorTarget.style.display = 'none'
      } else {
        this.isValidTel = false
        this.telErrorTarget.style.display = 'flex'
      }
    }
  }

  openText () {
    this.textTarget.classList.remove(this.displayHiddenClass)
  }

  closeText () {
    this.textTarget.classList.add(this.displayHiddenClass)
  }

  openLeaveModal () {
    if (!this.isDevelop) {
      this.closeLeaveModal()
      this.leaveModalTarget.classList.remove(this.displayHiddenClass)
      const chatQuestionContainer = document.getElementById('chat_question_container_leave')
      const loader1 = document.getElementById('chat_loader_leave_1')
      const loader2 = document.getElementById('chat_loader_leave_2')
      const chatQuestion1 = document.getElementById('chat_question_leave_1')
      const chatQuestion2 = document.getElementById('chat_question_leave_2')

      delay(() => {
        chatQuestionContainer.classList.add(this.visibilityVisibleClass)
      }, 800)
      delay(() => {
        loader1.classList.add(this.displayHiddenClass)
        chatQuestion1.classList.add(this.displayVisibleClass)
      }, 1600)
      delay(() => {
        loader2.classList.remove(this.displayHiddenClass)
      }, 2400)
      delay(() => {
        loader2.classList.add(this.displayHiddenClass)
        chatQuestion2.classList.add(this.displayVisibleClass)
      }, 3200)
    } else {
      console.log('open leave modal')
    }
  }

  closeLeaveModal () {
    this.leaveModalTarget.classList.add(this.displayHiddenClass)
    const chatQuestionContainer = document.getElementById('chat_question_container_leave')
    const loader1 = document.getElementById('chat_loader_leave_1')
    const loader2 = document.getElementById('chat_loader_leave_2')
    const chatQuestion1 = document.getElementById('chat_question_leave_1')
    const chatQuestion2 = document.getElementById('chat_question_leave_2')
    chatQuestionContainer.classList.remove(this.visibilityVisibleClass)
    loader1.classList.remove(this.displayHiddenClass)
    chatQuestion1.classList.remove(this.displayVisibleClass)
    loader2.classList.add(this.displayHiddenClass)
    chatQuestion2.classList.remove(this.displayVisibleClass)
  }

  fee (value) {
    return Math.round(value / 10000)
  }

  appendDiagnoseCarousel (results, carouselTarget, slideTarget) {
    slideTarget.innerHTML = ''

    results.forEach(result => {
      let admissionFee = ''
      let monthlyFee = ''
      let cost = ''
      let photo = ''
      let reviews = ''
      let vacancies = ''
      let info = ''
      const stations = []
      const labels = []

      if (result.low_admission_fee_total != null && result.high_admission_fee_total != null) {
        if (result.low_admission_fee_total === result.high_admission_fee_total) {
          admissionFee = `
            <div class="${this.className}::diagnose-form-slide__cost-fee">
              <span class="${this.className}::diagnose-form-slide__cost-heading">入居金</span>
              <span class="${this.className}::diagnose-form-slide__cost-value"><em>${this.fee(result.low_admission_fee_total)}</em>万円</span>
            </div>`
        } else {
          admissionFee = `
            <div class="${this.className}::diagnose-form-slide__cost-fee">
              <span class="${this.className}::diagnose-form-slide__cost-heading">入居金</span>
              <span class="${this.className}::diagnose-form-slide__cost-value"><em>${this.fee(result.low_admission_fee_total)}</em><span>〜</span><em>${this.fee(result.high_admission_fee_total)}</em>万円</span>
            </div>`
        }
      }

      if (result.low_monthly_fee_total != null && result.high_monthly_fee_total != null) {
        if (result.low_monthly_fee_total === result.high_monthly_fee_total) {
          monthlyFee = `
            <div class="${this.className}::diagnose-form-slide__cost-fee">
              <span class="${this.className}::diagnose-form-slide__cost-heading">月額</span>
              <span class="${this.className}::diagnose-form-slide__cost-value"><em>${this.fee(result.low_monthly_fee_total)}</em>万円</span>
            </div>`
        } else {
          monthlyFee = `
            <div class="${this.className}::diagnose-form-slide__cost-fee">
              <span class="${this.className}::diagnose-form-slide__cost-heading">月額</span>
              <span class="${this.className}::diagnose-form-slide__cost-value"><em>${this.fee(result.low_monthly_fee_total)}</em><span>〜</span><em>${this.fee(result.high_monthly_fee_total)}</em>万円</span>
            </div>`
        }
      }

      if (admissionFee || monthlyFee) {
        cost = `<div class="${this.className}::diagnose-form-slide__cost">${admissionFee + monthlyFee}</div>`
      }

      if (result.facility_image_url) {
        photo = `
          <a class="${this.className}::diagnose-form-slide__photo" href="${result.facility_url}" target="_blank" rel="noopener noreferrer">
            <img loading="lazy" alt="" width="176" height="176" src="${result.facility_image_url}">
          </a>`
      }

      if (result.reviews_count != null) {
        reviews = `<dl class="${this.className}::diagnose-form-slide__reviews"><dt>口コミ</dt><dd>口コミ<em>${result.reviews_count}</em>件</dd></dl>`
      }

      if (result.is_vacancy_displayable && result.vacancies_total != null) {
        vacancies = `<dl class="${this.className}::diagnose-form-slide__vacancies"><dt>空室</dt><dd>${result.vacancies_total}</dd></dl>`
      }

      if (photo || cost || (stations.length > 0)) {
        info = `
          <div class="${this.className}::diagnose-form-slide__info">
            ${photo}
            <div class="${this.className}::diagnose-form-slide__info-text">
              ${cost}
              <div class="${this.className}::diagnose-form-slide__stations">${stations.join('')}</div>
            </div>
          </div>`
      }

      result.near_stations.forEach(station => {
        stations.push(`<div class="${this.className}::diagnose-form-slide__station"><a href="${station.station_url}" target="_blank" rel="noopener noreferrer">${station.station_name}</a>から 徒歩${station.walking_time}分</div>`)
      })

      result.supported_care_level_labels.forEach(label => {
        const className = label.existence ? `${this.className}::diagnose-form-slide__label--exist` : ''
        labels.push(`<li class="${this.className}::diagnose-form-slide__label ${className}">${label.name}</li>`)
      })

      const content = `
        <div class="${this.className}::diagnose-form-slide swiper-slide">
          <div class="${this.className}::diagnose-form-slide__container">
            <div class="${this.className}::diagnose-form-slide__heading">
              <a href="${result.facility_url}" target="_blank" rel="noopener noreferrer">${result.facility_name}</a>
            </div>
            <div class="${this.className}::diagnose-form-slide__content">
              <div class="${this.className}::diagnose-form-slide__reviews-and-vacancies">${reviews + vacancies}</div>
              ${info}
            </div>
            <ul class="${this.className}::diagnose-form-slide__labels">${labels.join('')}</ul>
          </div>
        </div>
      `

      slideTarget.insertAdjacentHTML('beforeend', content)
    })

    const swiper = new Swiper(carouselTarget, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      lazyLoading: true,
      lazy: {
        loadPrevNext: true,
      },
      navigation: {
        prevEl: '#carousel_prev',
        nextEl: '#carousel_next',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        bulletClass: `${this.className}::bullet`,
        bulletActiveClass: `${this.className}::bullet-active`,
      },
    })

    swiper.enable()
  }

  appendAttributesCarousel (results, carouselTarget, slideTarget, attributeValue) {
    slideTarget.innerHTML = ''

    results.forEach((result, index) => {
      let admissionFee = ''
      let monthlyFee = ''
      let cost = ''
      let photo = ''

      if (result.low_admission_fee_total != null && result.high_admission_fee_total != null) {
        if (result.low_admission_fee_total === result.high_admission_fee_total) {
          admissionFee = `
            <div class="${this.className}::cost-fee">
              <span class="${this.className}::cost-heading">入居金</span>
              <span class="${this.className}::cost-value"><em>${this.fee(result.low_admission_fee_total)}</em>万円</span>
            </div>`
        } else {
          admissionFee = `
            <div class="${this.className}::cost-fee">
              <span class="${this.className}::cost-heading">入居金</span>
              <span class="${this.className}::cost-value"><em>${this.fee(result.low_admission_fee_total)}</em><span>〜</span><em>${this.fee(result.high_admission_fee_total)}</em>万円</span>
            </div>`
        }
      }

      if (result.low_monthly_fee_total != null && result.high_monthly_fee_total != null) {
        if (result.low_monthly_fee_total === result.high_monthly_fee_total) {
          monthlyFee = `
            <div class="${this.className}::cost-fee">
              <span class="${this.className}::cost-heading">月額</span>
              <span class="${this.className}::cost-value"><em>${this.fee(result.low_monthly_fee_total)}</em>万円</span>
            </div>`
        } else {
          monthlyFee = `
            <div class="${this.className}::cost-fee">
              <span class="${this.className}::cost-heading">月額</span>
              <span class="${this.className}::cost-value"><em>${this.fee(result.low_monthly_fee_total)}</em><span>〜</span><em>${this.fee(result.high_monthly_fee_total)}</em>万円</span>
            </div>`
        }
      }

      if (admissionFee || monthlyFee) {
        cost = `
          <div class="${this.className}::facility-cost">
            <div class="${this.className}::cost">
              ${admissionFee}
              ${monthlyFee}
            </div>
          </div>`
      }

      if (result.facility_image_url) {
        photo = `
          <div class="${this.className}::facility-photo">
            <img loading="lazy" alt="" width="116" height="116" src="${result.facility_image_url}">
          </div>`
      }

      const content = `
        <div class="${this.className}::facility-slide swiper-slide">
          <div class="${this.className}::facility-check">
            <label class="${this.className}::checkbox">
              <input
                type='checkbox'
                name='inquiry[inquiry_facilities_attributes][${index}][${attributeValue}]'
                value='true' />
              <i></i>
            </label>
            <span>お問い合わせ施設</span>
          </div>
          <div class="${this.className}::facility-info">
            ${photo}
            <div class="${this.className}::facility-info-content">
              <div class="${this.className}::facility-heading">
                <a href="${result.facility_url}" target="_blank" rel="noopener noreferrer">${result.facility_name}</a>
              </div>
              <div class="${this.className}::facility-category">グループホーム</div>
              ${cost}
            </div>
          </div>
          <input name="inquiry[inquiry_facilities_attributes][${index}][facility_id]" type="hidden" value="${result.facility_id}">
        </div>
      `

      slideTarget.insertAdjacentHTML('beforeend', content)
    })

    const swiper = new Swiper(carouselTarget, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      lazyLoading: true,
      lazy: {
        loadPrevNext: true,
      },
      navigation: {
        prevEl: '#carousel_prev',
        nextEl: '#carousel_next',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        bulletClass: `${this.className}::bullet`,
        bulletActiveClass: `${this.className}::bullet-active`,
      },
    })

    swiper.enable()
  }
}
